import React, { useState } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./TrainingAndDevelopment.css";
import Footer from "./Footer";

const trainingPrograms = [
  {
    name: "AutoCAD",
    description:
      "Comprehensive AutoCAD training covering 2D drafting and design.",
    image: "/2d.jpg",
  },
  {
    name: "2D Drafting",
    description:
      "Learn precise 2D drafting techniques for engineering projects.",
    image: "/programs/2d-drafting.jpg",
  },
  {
    name: "3D Modeling",
    description: "Master 3D modeling skills using industry-standard software.",
    image: "/programs/3d-modeling.jpg",
  },
  {
    name: "Revit",
    description:
      "In-depth Revit training for building information modeling (BIM).",
    image: "/programs/revit.jpg",
  },
  {
    name: "Inventor",
    description:
      "Professional training in Autodesk Inventor for 3D mechanical design.",
    image: "/programs/inventor.jpg",
  },
];

const testimonials = [
  {
    name: "Sayan Bera",
    feedback:
      "The training programs helped me advance my career significantly.",
    image: "/student/1.jpg",
  },
  {
    name: "Saikat Naskar",
    feedback: "Excellent trainers and comprehensive course material.",
    image: "/student/2.jpg",
  },
  {
    name: "Amiya Biswas",
    feedback: "Practical and hands-on training that made learning easy.",
    image: "/student/3.jpg",
  },
  {
    name: "Tama Mukhopadhyay",
    feedback: "Highly recommend the courses for practical knowledge.",
    image: "/student/Tama.jpg",
  },
  {
    name: "Ayan Purkait",
    feedback: "The trainers are very supportive and knowledgeable.",
    image: "/student/Ayan Purkait.jpg",
  },
  {
    name: "Chayan Naskar",
    feedback: "Great learning environment and course content.",
    image: "/student/Chayan Naskar.jpg",
  },
  {
    name: "Susanta Das",
    feedback: "The hands-on approach helped me a lot in my projects.",
    image: "/student/Susanta Das.jpg",
  },
  {
    name: "Tanmay Saha",
    feedback: "The trainers are very supportive and knowledgeable.",
    image: "/student/Tanmay Saha.jpg",
  },
  {
    name: "Niloy Dey",
    feedback: "The trainers provide excellent support and possess deep knowledge in their field.",
    image: "/student/Nilay.jpg",
  },
];

const TrainingAndDevelopment = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const navigate = useNavigate();

  const handleCardClick = (program) => {
    navigate(`/tandd/${program.name}`);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedProgram(null);
  };

  const handleKnowMoreClick = () => {
    navigate("/jpe");
  };

  return (
    <div className="training-development-page">
      {/* Hero Section */}
      <div
        className="td-hero-section d-flex align-items-center justify-content-center text-white"
        style={{
          backgroundImage: "url('/t&d/2.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          minHeight: "90vh",
          paddingTop: "140px", // Fixed overlap
          paddingBottom: "60px",
          position: "relative",
        }}
      >
        {/* <Container className="text-center" style={{ zIndex: 2 }}>
          <h1 className="td-hero-title">Training & Development</h1>
          <p className="td-hero-subtitle">
            Master design and drafting software through expert-led training.
          </p>
        </Container> */}
      </div>

      {/* About Section */}
      <Container className="td-about-section py-5">
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="section-title">About Our Training</h2>
            <p>
              We offer hands-on training in the most in-demand engineering
              software. Our focus is on practical learning, real-world
              application, and professional development.
            </p>
          </Col>
          <Col md={6}>
            <img
              src="/t&d/1.png"
              alt="Training"
              className="img-fluid rounded shadow-sm"
            />
          </Col>
        </Row>
      </Container>

      {/* Design and Drafting Programs */}
      <Container className="py-5">
        <h2 className="text-center section-title">
          Design and Drafting Programs
        </h2>
        <Row className="mt-4">
          {trainingPrograms.map((program, index) => (
            <Col md={4} sm={6} key={index} className="mb-4">
              <Card
                className="td-program-card"
                onClick={() => handleCardClick(program)}
                style={{ cursor: "pointer" }}
              >
                <Card.Body>
                  <Card.Title className="text-center">
                    {program.name}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>

      {/* JPE Section */}
      <Container className="td-jpe-section py-5 bg-light rounded shadow-sm">
        <Row className="align-items-center">
          <Col md={6}>
            <h2 className="section-title">Junior Project Engineer (JPE)</h2>
            <p>
              Our JPE program is designed to prepare junior project engineers
              with the skills and knowledge needed to excel in the industry.
            </p>
            <Button variant="primary" onClick={handleKnowMoreClick}>
              Know More
            </Button>
          </Col>
          <Col md={6}>
            <img
              src="/t&d/3.jpeg"
              alt="Junior Project Engineer"
              className="img-fluid rounded"
            />
          </Col>
        </Row>
      </Container>

      {/* Testimonials */}
      <Container className="py-5">
        <h2 className="text-center section-title">What People Say</h2>
        <div className="testimonial-row d-flex overflow-auto">
          {testimonials.map((t, index) => (
            <div
              key={index}
              className="testimonial-item flex-shrink-0 mx-3"
              style={{ minWidth: "300px" }}
            >
              <div className="d-flex flex-column align-items-center">
                <img
                  src={t.image}
                  alt={t.name}
                  className="testimonial-img mb-3"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "0",
                  }}
                />
                <Card
                  className="td-testimonial-card text-center"
                  style={{ maxWidth: "600px" }}
                >
                  <Card.Body>
                    <Card.Text>"{t.feedback}"</Card.Text>
                    <Card.Subtitle className="text-muted mt-2">
                      — {t.name}
                    </Card.Subtitle>
                  </Card.Body>
                </Card>
              </div>
            </div>
          ))}
        </div>
      </Container>

      {/* Contact Box */}
      {/* <div className="td-contact-container">
        <Container className="td-contact-content d-flex justify-content-between align-items-center">
          <div className="td-contact-left">
            <h3>Need A Free Quote?</h3>
            <p>We would love to talk!</p>
          </div>
          <div className="td-contact-right">
            <a href="tel:+917044478562" className="td-contact-phone-btn">
              <span role="img" aria-label="phone">
                📞
              </span>{" "}
              +91-7044478562
            </a>
            <p className="td-contact-support">
              <span role="img" aria-label="headset">
                🎧
              </span>{" "}
              24 hrs telephone support
            </p>
          </div>
        </Container>
      </div> */}

      <Footer />
    </div>
  );
};

export default TrainingAndDevelopment;
